import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from '../config/config.json';
import { useDispatch } from 'react-redux';
import {
  setTypes,
  setCategories,
  setRarities,
  setStats,
  setLoading,
  setError,
} from '../features/staticData/staticDataSlice';

export function useStaticData() {
  const dispatch = useDispatch();
  const sessionToken = localStorage.getItem('session_token');

  const fetchTypes = async () => {
    try {
      dispatch(setLoading({ key: 'types', value: true }));
      const headers = sessionToken ? { 'session-token': sessionToken } : {};
      const response = await axios.get(`${config.backend_base_url}types/all`, {
        headers,
      });
      dispatch(setTypes(response.data));
      return response.data;
    } catch (error) {
      dispatch(setError({ key: 'types', value: 'Error fetching types' }));
      throw error;
    }
  };

  const fetchCategories = async () => {
    try {
      dispatch(setLoading({ key: 'categories', value: true }));
      const headers = sessionToken ? { 'session-token': sessionToken } : {};
      const response = await axios.get(`${config.backend_base_url}categories/all`, {
        headers,
      });
      dispatch(setCategories(response.data));
      return response.data;
    } catch (error) {
      dispatch(setError({ key: 'categories', value: 'Error fetching categories' }));
      throw error;
    }
  };

  const fetchRarities = async () => {
    try {
      dispatch(setLoading({ key: 'rarities', value: true }));
      const headers = sessionToken ? { 'session-token': sessionToken } : {};
      const response = await axios.get(`${config.backend_base_url}rarities/all`, {
        headers,
      });
      dispatch(setRarities(response.data));
      return response.data;
    } catch (error) {
      dispatch(setError({ key: 'rarities', value: 'Error fetching rarities' }));
      throw error;
    }
  };

  const fetchStats = async () => {
    try {
      dispatch(setLoading({ key: 'stats', value: true }));
      const headers = sessionToken ? { 'session-token': sessionToken } : {};
      const response = await axios.get(`${config.backend_base_url}stats/all`, {
        headers,
      });
      dispatch(setStats(response.data));
      return response.data;
    } catch (error) {
      dispatch(setError({ key: 'stats', value: 'Error fetching stats' }));
      throw error;
    }
  };

  const typesQuery = useQuery({
    queryKey: ['types'],
    queryFn: fetchTypes,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  const categoriesQuery = useQuery({
    queryKey: ['categories'],
    queryFn: fetchCategories,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  const raritiesQuery = useQuery({
    queryKey: ['rarities'],
    queryFn: fetchRarities,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  const statsQuery = useQuery({
    queryKey: ['stats'],
    queryFn: fetchStats,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    typesQuery,
    categoriesQuery,
    raritiesQuery,
    statsQuery,
  };
}
